import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const location = useLocation();

  return (
    <header className="app-header">
      <div className="header-content">
        <Link to="/" className="logo-container">
          <span className="logo-text">YAP</span>
          <span className="logo-live">LIVE</span>
        </Link>

        <nav className="nav-links">
          {location.pathname.includes('/watch') && (
            <div className="live-indicator">
              <span className="live-dot"></span>
              LIVE
            </div>
          )}
        </nav>
      </div>
    </header>
  );
};

export default Header; 